/**
 * 관리자 오더 연간 합계
 * ($j.Pages.Admin.OrderYearly / body data-page-name="OrderYearly")
 *
 * 작업일(work_day) 기준 월별 건수·금액을 전년과 나란히, 장비별로 쪼개어 본다.
 * 취소(99)·자체배차(임의발주 91) 제외 — 기준은 App\Services\Stat\OrderStatService.
 */
export default class OrderYearly {
    constructor() {
        this.data = null;
    }

    initialize() {
        $('#oyYear').on('change', () => this._load());
        $('#oyRefresh').on('click', () => this._load(true));
        $('#oyExcel').on('click', (e) => {
            e.preventDefault();
            location.href = `/excel/stat/order-yearly?year=${this._year()}`;
        });
        this._load();
    }

    _year() { return String($('#oyYear').val() || ''); }

    async _load(nocache = false) {
        try {
            const data = { year: this._year() };
            if (nocache) data.nocache = 1;
            const res = await $.ajax({ url: '/adm/ajax/stat/orders/yearly', type: 'get', data });
            if (!res.ok) return;
            this.data = res;
            this._renderHead(res);
            this._renderBody(res);
            this._renderSummary(res);
            $('#oyTitle').text(`${res.year}년도 전체 오더 합계 (작업일 기준)`);
            if (res.cached_at) $('#oyCachedAt').text(`집계 ${res.cached_at}`);
        } catch (e) {
            console.error('오더 연간 합계 로드 실패', e);
        }
    }

    _renderHead(d) {
        const top = [
            '<th rowspan="2" class="oy-month">구분</th>',
            `<th colspan="2">${d.prev_year}년도</th>`,
            `<th colspan="2" class="oy-sep">${d.year}년도</th>`,
            ...d.cars.map(c => `<th colspan="2" class="oy-sep">${c}</th>`),
            `<th colspan="${d.ratio_cars.length}" class="oy-sep">비율(금액기준)</th>`,
        ].join('');

        const pair = (sep) => `<th class="${sep ? 'oy-sep' : ''}">건수</th><th>금액</th>`;
        const sub = [
            pair(false),
            pair(true),
            ...d.cars.map(() => pair(true)),
            d.ratio_cars.map((c, i) => `<th class="${i === 0 ? 'oy-sep' : ''}">${c}</th>`).join(''),
        ].join('');

        $('#oyTable thead').html(`<tr>${top}</tr><tr>${sub}</tr>`);
    }

    _renderBody(d) {
        const rows = d.rows.map(r => this._row(d, r, `${r.month}월`, ''));
        rows.push(this._row(d, d.total, '누계', 'oy-total'));
        $('#oyTable tbody').html(rows.join(''));
    }

    _row(d, r, label, cls) {
        const cells = [
            `<td class="oy-month">${label}</td>`,
            `<td class="num oy-prev">${this._c(r.prev.cnt)}</td><td class="num oy-prev">${this._c(r.prev.amt)}</td>`,
            `<td class="num oy-sep oy-cur">${this._c(r.cur.cnt)}</td><td class="num oy-cur">${this._c(r.cur.amt)}</td>`,
            ...d.cars.map(c => `<td class="num oy-sep">${this._c(r.cars[c].cnt)}</td><td class="num">${this._c(r.cars[c].amt)}</td>`),
            d.ratio_cars.map((c, i) => `<td class="num oy-cur ${i === 0 ? 'oy-sep' : ''}">${this._pct(r.ratio[c])}</td>`).join(''),
        ].join('');

        return `<tr class="${cls}">${cells}</tr>`;
    }

    _renderSummary(d) {
        const cur = d.total.cur;
        const prev = d.total.prev;
        $('#oyCurLabel').text(`${d.year}년 건수`);
        $('#oyPrevLabel').text(`${d.prev_year}년 건수`);
        $('#oyCurCnt').text(this._c(cur.cnt) + '건');
        $('#oyCurAmt').text(this._won(cur.amt));
        $('#oyPrevCnt').text(this._c(prev.cnt) + '건');
        $('#oyPrevAmt').text(this._won(prev.amt));

        // 연 누계끼리 비교하면 진행중인 해가 무조건 손해로 보인다 — 말일 지난 달까지만 전년과 맞대본다
        if (d.last_month < 1) {
            // 1월 중이라 올해 말일 지난 달이 아직 없다 — 비교할 게 없다
            $('.oy-period').text('전년 동기 대비 (아직 말일 지난 달 없음)');
            $('#oyDiffCnt, #oyDiffAmt').text('-').css('color', '');
            return;
        }
        const p = this._samePeriod(d);
        $('.oy-period').text(`${d.prev_year}년 1~${d.last_month}월 대비`);
        this._diff('#oyDiffCnt', p.cur.cnt, p.prev.cnt, (n) => this._c(n) + '건');
        this._diff('#oyDiffAmt', p.cur.amt, p.prev.amt, (n) => this._won(n));
    }

    /**
     * 말일 지난 달까지의 올해·전년 합 (전년 동기 비교용).
     * 끝 달은 서버(last_month)가 준다 — 작업일이 미래인 오더가 섞여 있어 데이터로는 못 정한다.
     */
    _samePeriod(d) {
        const sum = { cur: { cnt: 0, amt: 0 }, prev: { cnt: 0, amt: 0 } };
        d.rows.filter(r => r.month <= d.last_month).forEach(r => {
            ['cur', 'prev'].forEach(k => { sum[k].cnt += r[k].cnt; sum[k].amt += r[k].amt; });
        });
        return sum;
    }

    /** 전년 대비 증감 — 부호와 색을 함께 */
    _diff(sel, cur, prev, fmt) {
        const gap = cur - prev;
        const pct = prev > 0 ? Math.round(gap / prev * 100) : null;
        const sign = gap > 0 ? '+' : '';
        const $el = $(sel);
        $el.text(`${sign}${fmt(gap)}` + (pct === null ? '' : ` (${sign}${pct}%)`));
        $el.css('color', gap < 0 ? 'var(--adm-bs-danger)' : 'var(--adm-bs-success)');
    }

    _pct(v) { return (v === null || v === undefined) ? '-' : `${v}%`; }

    _won(n) {
        n = Number(n || 0);
        const sign = n < 0 ? '-' : '';
        const abs = Math.abs(n);
        if (abs >= 1e8) return `${sign}${(abs / 1e8).toFixed(1)}억`;
        if (abs >= 1e4) return `${sign}${Math.round(abs / 1e4).toLocaleString()}만`;
        return `${sign}${abs.toLocaleString()}`;
    }

    _c(n) {
        n = Number(n || 0);
        return n === 0 ? '-' : n.toLocaleString();
    }
}